import { render } from "./classify.vue?vue&type=template&id=ad34993c&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"

import "./classify.vue?vue&type=style&index=0&id=ad34993c&lang=scss&scoped=true"
import "./classify.vue?vue&type=style&index=1&id=ad34993c&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad34993c"]])

export default __exports__